import logo from "./logo.svg";
import logo_dark from "./logo_dark.svg";
import map from "./map.jpg";

export const assets = {
  logo,
  logo_dark,
  map,
};
